import React from 'react'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SubmenuWarehouse from '../submenu/SubmenuWarehouse'
import PackingConfirmForm from './form/PackingConfirmForm'

const PackingConfirm = () => {
  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuWarehouse />
		</MyBlock>
        <MyBlockHeader
            header={'Підтвердження факту пакування товарів в коробку'}
            // isBack={true}
            // options={
            //     <FactoryOneOptions 
            //         factoryId={id}
            //     />
            // }
        />
        {/* <MyBlock>
            <BoxOneOptions 
                boxId={boxId}
            />
        </MyBlock> */}
		<MyBlock>
            <PackingConfirmForm />
		</MyBlock>
    </LayoutMain>
  )
}

export default PackingConfirm